var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTravelicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 110,
    viewBox: "0 0 108 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0996094 51.8997C1.59961 127.3 111.6 128.699 106.8 56.1995C112.3 -14.4005 10.9996 -19.1003 0.0996094 51.8997ZM80.4004 64.1995C73.6004 65.4995 69.5998 64.4998 64.2998 64.4998C59.5998 63.1998 63.3002 71.5998 49.2002 82.4998C39.6002 88.1998 46.0002 73.0997 50.2002 64.8997C51.8002 63.7997 39.7002 64.1998 35.2002 63.9998C24.7002 63.1998 27.5004 67.7996 25.4004 50.7996C24.0004 36.4996 24.2004 27.5995 27.9004 32.6995C39.4004 50.6995 24.2998 45.7998 58.2998 46.4998C60.7998 47.9998 63.2998 34.4997 67.2998 35.3997C69.3998 37.2997 67.9998 46.2996 68.2998 46.2996C68.5998 46.7996 70.2998 46.3998 76.2998 46.4998C89.3998 46.6998 92.9004 60.3995 80.4004 64.1995Z",
    fill: "#1A3668"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelicon);
export default __webpack_public_path__ + "static/media/travelicon.9c448701ef9681c217613e93ce9302c3.svg";
export { ForwardRef as ReactComponent };